import { createStyles, makeStyles } from '@material-ui/styles';
import ACF from '../../../../../../assets/background/ngo/spa.webp';
import PU from '../../../../../../assets/background/ngo/forest.webp';
import UEPM from '../../../../../../assets/background/ngo/child.webp';
import palette from '../../../../../../theme/palette';

const style = () =>
  createStyles({
    title: {
      color: palette.text.primary
    },
    ngo: {
      marginTop: '1.5rem'
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
      padding: '1rem'
    },
    ngoName: {
      textAlign: 'center',
      marginTop: '1rem',
      marginBottom: '1rem'
    },
    ngoContainer: {
      marginTop: '1rem',
      borderRadius: '10px',
      overflow: 'hidden',
      boxShadow: palette.shadows.boxShadow
    },
    image: {
      width: '100%',
      height: '75px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: 'white'
    },
    Planete_urgence: {
      backgroundImage: `url(${PU})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center'
    },
    Un_enfant_par_la_main: {
      backgroundImage: `url(${UEPM})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center'
    },
    Societe_protectrice_des_animaux: {
      backgroundImage: `url(${ACF})`,
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '50% 10%'
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
